module.exports = __webpack_public_path__ + "static/media/sound.4355078f.mp3";